import script from "./ReviewsLinker.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewsLinker.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__